import MiniGameImages from "../../MiniGameImages";

export default class EitherOrParticipationStepsOptionModel {
  public id: string = "";
  public label: string = "";
  public images: MiniGameImages = new MiniGameImages();
  public value: number = null;
}
